module.exports = __webpack_public_path__ + "img/movieTheater-1.996306bb.jpg";